<template>
    <div>
        <b-tabs v-model="activeTab">
            <b-tab-item label="Configuración Básica">
                <div v-if="ready">
                    <div class="columns">
                        <div class="column is-3">
                            <figure class="image is-circle">
                                <div class="overlay">

                                </div>
                                <img :src="provider.logo">
                            </figure>
                        </div>
                        <div class="column">
                            <p><strong>Nombre: </strong>{{provider.name}}</p>
                            <p><strong>Teléfono: </strong>{{provider.phone}}</p>
                            <p><strong>Extensión: </strong>{{provider.extension}}</p>
                        </div>
                    </div>
                </div>
            </b-tab-item>

            <b-tab-item label="Operadores">
                <data-table url="ivr/worker"
                            model="Worker" :fields="workerFields"
                            action-buttons primary-key="uuid" no-modal
                            :extraParams="workerParams"
                            create
                ></data-table>
            </b-tab-item>
        </b-tabs>
    </div>
</template>

<script>
    export default {
        name: "Show",
        props: {
            uuid: String,
        },
        data() {
            return {
                activeTab: 0,
                workerFields: [
                    // { field: 'uuid', label: 'UUID', sort: true, hasFilter: false, filter: '', filterAdd: null  },
                    { field: 'user.profile.fullName', label: 'Nombre', sort: false, hasFilter: false, filter: '', filterAdd: null  },
                    { field: 'user.email', label: 'Email', sort: false, hasFilter: false, filter: '', filterAdd: null  },
                    { field: 'extension', label: 'Extensión', sort: true, hasFilter: false, filter: '', filterAdd: null  },
                    { field: 'personal_phone', label: 'Teléfono Directo', sort: true, hasFilter: false, filter: '', filterAdd: null  },
                    { field: 'activity.name', label: 'Status', sort: false, hasFilter: false, filter: '', filterAdd: null  },
                ],
                workerParams: {provider: this.uuid},
                provider: {},
                ready: false,
            }
        },
        mounted() {
            this.prepareComponent();
        },
        methods: {
            prepareComponent() {
                this.$root.preloader = false;
                this.getProvider();
            },
            getProvider() {
                this.ready = false;
                this.$http.get('/ivr/provider/' + this.uuid).then(response => {
                    this.provider = response.data.data;
                    setTimeout(() => {
                        this.ready = true;
                    }, 500)
                }, error => {
                    this.ready = false;
                })
            },
        }
    }
</script>

<style scoped>

</style>
